import { createForms } from 'react-redux-form';
import Moment from 'moment';

const initialUserState = {
    date: Moment(),
    options: [
        { name: 'Select 1', code: '1' },
        { name: 'Select 2', code: '2' },
        { name: 'Select 3', code: '3' }
    ]
};

const initialDevLogin = {
    username: null,
    password: null
};

const initialSearchState = {
    name: '',
    startDate: Moment().subtract(45, 'days'),
    endDate: Moment().add(45, 'days'),
    // startDate: '2019-07-17',
    // endDate: '',
    // districtCode: [{ name: 'All', code: '' }],
    // regionCode: [
    //     { name: 'National', code: '' },
    //     { name: 'Western', code: 'west' },
    //     { name: 'Eastern', code: 'east' }
    // ],
    // recruitingStationCode: [{ name: 'All', code: '' }],
    // rssOssCode: [{ name: 'All', code: '' }],
    rssOssType: '',
    eventStatus: [],
    eventReportStatus: []
};

const initialEventState = {
    name: '',
    id: null,
    approverId: null,
    contract: null,
    endTime: '',
    purpose: null,
    estAttendance: null,
    isFromEac: null,
    startTime: '',
    state: null,
    cost: null,
    city: '',
    uploadedFiles: [],
    vendorForm: {},
    vendorsInformation: [],
    behavior: false,
    awareness: false,
    sDate: null,
    eDate: null,
    tShirt: 0,
    lanyards: 0,
    waterBottles: 0,
    hats: 0,
    promoTotal: 0,
    newPromoLineItem: {},
    promoLineItems: [],
    eventFile: [],
    category: [],
    eacCode: null,
    assignmentOption: null,
    fiscalYear: null,
    showParentIdField: null,
    estEngagements: null,
    estMediaPosts: null,
    estMediaImpressions: null,
    estSocialMediaPosts: null,
    estSocialMediaImpressions: null,
    estQualifiedLeads: null,
    estInfluencerContacts: null,
    estFollowUps: null,
    estInteraction: null,
    estInfluencerInteraction: null,
    deliverable: null,
    addlDeliverables: null,
    estOnsiteActivations: null,
    dateContractedSigned: null,
    aabehavior: false,
    aaawareness: false,
    ossRssType: null
};

const initialPurchaseRequestState = {
    name: '',
    totalCost: '',
    dateCreated: '',
    dateRequired: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    itemizedCost: '',
    PurchaseRequestItem: [],
    newItem: {
        purchaseRequestId: null,
        unitOfIssue: 'EACH'
    },
    id: null,
    Documents: [],
    Photos: []
};

const initialCalendarFilterState = {
    // districtCode: [{ name: 'All', code: '' }],
    // regionCode: [
    //     { name: 'National', code: '' },
    //     { name: 'Western', code: 'west' },
    //     { name: 'Eastern', code: 'east' }
    // ],
    // recruitingStationCode: [{ name: 'All', code: '' }],
    // rssOssCode: [{ name: 'All', code: '' }]
};

const initialReportingState = {
    // districtCode: [{ name: 'All', code: '' }],
    // regionCode: [
    //     { name: 'National', code: '' },
    //     { name: 'Western', code: 'west' },
    //     { name: 'Eastern', code: 'east' }
    // ],
    // recruitingStationCode: [{ name: 'All', code: '' }],
    // rssOssCode: [{ name: 'All', code: '' }],
    rssOssType: '',
    eventStatus: [],
    eventReportStatus: [],
    startDate: Moment().add(-60, 'days'),
    endDate: Moment(),
    eventStatusReport: false,
    ethnicity: []
};
const initialAdmin = {
    events: [],
    reports: [],
    tasks: [],
    allEvents: [],
    allReports: [],
    allTasks: [],
    currentlyAssignedTo: '',
    reassignTo: '',
    inActive: []
};

export default createForms({
    user: initialUserState,
    search: initialSearchState,
    calendarFilters: initialCalendarFilterState,
    event: initialEventState,
    reportingFilters: initialReportingState,
    PurchaseRequest: initialPurchaseRequestState,
    devLogin: initialDevLogin,
    adminForm: initialAdmin
});



// WEBPACK FOOTER //
// ./src/reducers/forms.js